module.exports = __webpack_public_path__ + "img/PMS_GT.cc0f965c.gif";